// extracted by mini-css-extract-plugin
export default {"contentStyle":"EditCampaignSaveModal_contentStyle__NBNKA","container":"EditCampaignSaveModal_container__vpWt7","footer":"EditCampaignSaveModal_footer__HYmuJ"};